module.exports = __webpack_public_path__ + "../resources/img/ci_img0.04e00d62.png";